/* Structure Beauty cart drawer: discount code field.
   The code is saved with Shopify's /discount/CODE route, so checkout applies it. */
(function () {
  if (window.__sbCartCode) return;
  window.__sbCartCode = true;

  function apply(wrap) {
    var input = wrap.querySelector('[data-sb-code-input]');
    var btn = wrap.querySelector('[data-sb-code-add]');
    var msg = wrap.querySelector('[data-sb-code-msg]');
    var code = (input.value || '').trim();
    if (!code) {
      msg.textContent = 'Enter a discount code.';
      return;
    }
    btn.disabled = true;
    msg.textContent = 'Saving code…';
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
      .then(function () {
        msg.textContent = 'Code ' + code.toUpperCase() + ' will be applied at checkout.';
      })
      .catch(function () {
        msg.textContent = 'Could not save that code. Please try again.';
      })
      .then(function () {
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-code-add]');
    if (!btn) return;
    e.preventDefault();
    apply(btn.closest('[data-sb-code]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-sb-code-input]');
    if (!input) return;
    e.preventDefault();
    apply(input.closest('[data-sb-code]'));
  });
})();
